import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.filteredEvents,"item-value":_vm.itemValue,"item-text":_vm.itemText,"label":_vm.label,"multiple":_vm.multiple,"clearable":_vm.clearable,"dense":_vm.dense,"outlined":_vm.outlined,"hint":String(_vm.localValue)},on:{"change":_vm.handleChange},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }